import { render, staticRenderFns } from "./EtpGauge.vue?vue&type=template&id=56b1d602&scoped=true&"
import script from "./EtpGauge.vue?vue&type=script&lang=ts&"
export * from "./EtpGauge.vue?vue&type=script&lang=ts&"
import style0 from "./EtpGauge.vue?vue&type=style&index=0&id=56b1d602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b1d602",
  null
  
)

export default component.exports